import React, { useCallback, useMemo } from 'react';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { LineChart, IChartProps } from '@fluentui/react-charting';

const useStyles = makeStyles({
  inlineChart: {
    height: '290px',
  },
});

export const InlineChart = (props) => {
  const { data } = props;
  const classes = useStyles();
  const getColor = useCallback((metricName) => {
    if (metricName === 'Clicks') {
      return 'rgba(227, 0, 140, 1)';
    } else if (metricName === 'CTR') {
      return 'rgba(99, 124, 239, 1)';
    } else if (metricName === 'Impressions') {
      return 'rgba(42, 160, 164, 1)';
    }
    return 'gray';
  }, []);

  const lineChartData = useMemo(() => {
    if (!data || !Array.isArray(data)) {
      return [];
    }
    const result: { legend: string; data: { x: Date; y: number; }[]; color: string }[] = [];
    data.forEach(({ MetricName, PrimaryDataPoints, ComparisonDataPoints }) => {
      const lineData = {
        legend: MetricName,
        data: Array.isArray(PrimaryDataPoints) ? PrimaryDataPoints.map(({ DateTime, Value }) => ({ x: new Date(DateTime), y: Value })) : [],
        color: getColor(MetricName),
        lineOptions: {
          strokeWidth: '2px',
        },
      };
      const comparisonData = {
        legend: `Average ${MetricName} in your library`,
        legendShape: 'dottedLine',
        data: Array.isArray(ComparisonDataPoints) ? ComparisonDataPoints.map(({ DateTime, Value }) => ({ x: new Date(DateTime), y: Value })) : [],
        color: 'gray',
        lineOptions: {
          strokeDasharray: '2px',
          strokeDashoffset: '-1',
          strokeLinecap: 'butt',
          strokeWidth: '2px',
        },
      };
      if (lineData.data.length) {
        result.push(lineData);
      }
      if (comparisonData.data.length) {
        result.push(comparisonData);
      }
    });
    return result;
  }, [data, getColor]);

  const chartData: IChartProps = useMemo(() => ({
    chartTitle: '',
    lineChartData,
  }), [lineChartData]);

  return (
    <LineChart
      data={chartData}
      legendsOverflowText={'Overflow Items'}
      className={mergeClasses('inline-chart', classes.inlineChart)}
      allowMultipleShapesForPoints
    />
  );
};
